import { render, staticRenderFns } from "./GroupConfigurator.vue?vue&type=template&id=a2feff60&lang=pug"
import script from "./GroupConfigurator.vue?vue&type=script&lang=js"
export * from "./GroupConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports